export default __webpack_public_path__ + "static/media/dashboard-male-icon.188dd219.svg";